<template>
  <v-row dense class="orientacao-cards-row align-stretch">
    <v-col cols="12" md="6" class="d-flex">
      <v-card outlined class="orientacao-card flex-grow-1">
        <v-card-text class="orientacao-card-body">
          <h4 class="orientacao-card-heading mb-2">Nome dos arquivos</h4>
          <p class="orientacao-card-text mb-3">
            Use o código do produto e, se houver mais de uma imagem, adicione um
            número sequencial.
          </p>
          <div class="orientacao-card-visual">
            <div class="orientacao-exemplos-grid">
              <div
                v-for="exemplo in exemplosArquivo"
                :key="exemplo.arquivo"
                class="orientacao-exemplo-item"
              >
                <div class="orientacao-exemplo-thumb-wrap">
                  <img
                    :src="exemploProdutoImg"
                    alt=""
                    class="orientacao-exemplo-thumb"
                  />
                  <span class="orientacao-exemplo-check">
                    <v-icon color="white" size="12">fas fa-check</v-icon>
                  </span>
                </div>
                <div class="orientacao-exemplo-arquivo">
                  {{ exemplo.arquivo }}
                </div>
                <div class="orientacao-exemplo-legenda">
                  {{ exemplo.legenda }}
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" md="6" class="d-flex">
      <v-card outlined class="orientacao-card flex-grow-1">
        <v-card-text class="orientacao-card-body">
          <h4 class="orientacao-card-heading mb-2">Como organizar o ZIP</h4>
          <p class="orientacao-card-text mb-3">
            Compacte todas as imagens em um único arquivo ZIP, mantendo apenas
            os arquivos de imagem na raiz.
          </p>
          <div class="orientacao-card-visual">
            <div class="orientacao-zip-diagram">
              <div class="orientacao-zip-icon-block">
                <v-icon color="#bdbdbd" size="56">fas fa-file-archive</v-icon>
                <div class="orientacao-zip-icon-label">PRODUTOS.ZIP</div>
              </div>
              <div class="orientacao-zip-bracket" aria-hidden="true"></div>
              <ul class="orientacao-zip-file-list mb-0">
                <li v-for="file in zipExampleFiles" :key="file">
                  <v-icon color="primario" size="14" class="mr-2"
                    >far fa-image</v-icon
                  >
                  {{ file }}
                </li>
              </ul>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import exemploProdutoImg from "@/assets/imagemproduto/exemplo-produto-cadeira.jpg";

export default {
  name: "ImagemProdutoOrientacao",
  data: () => ({
    exemploProdutoImg,
    exemplosArquivo: [
      {
        arquivo: "789654321.jpg",
        legenda: "Imagem principal sem numeração"
      },
      {
        arquivo: "789654321(2).jpg",
        legenda: "Segunda imagem com numeração"
      }
    ],
    zipExampleFiles: [
      "789654321.jpg",
      "789654321(2).jpg",
      "789987654.jpg",
      "789987654(2).png"
    ]
  })
};
</script>

<style lang="scss" scoped>
.orientacao-card ::v-deep .v-card__text {
  height: 100%;
}

.orientacao-cards-row > .col {
  padding-top: 0;
  padding-bottom: 0;
}

.orientacao-card {
  width: 100%;
  border-radius: 8px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.orientacao-card-body {
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 18px !important;
}

.orientacao-card-visual {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 148px;
  text-align: center;
}

.orientacao-card-heading {
  font-size: 15px;
  font-weight: 700;
  color: var(--primary-color, #1976d2);
}

.orientacao-card-text {
  font-size: 13px;
  line-height: 1.5;
  opacity: 0.87;
  min-height: 38px;
}

.orientacao-exemplos-grid {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 20px;
  row-gap: 0;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(76, 175, 80, 0.08);
  border: 1px solid rgba(76, 175, 80, 0.22);
  width: fit-content;
  max-width: calc(100% - 8px);
  margin: 0 auto;
}

.orientacao-exemplo-item {
  text-align: center;
}

.orientacao-exemplo-thumb-wrap {
  position: relative;
  display: inline-block;
  margin-bottom: 8px;
}

.orientacao-exemplo-thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
}

.orientacao-exemplo-check {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orientacao-exemplo-arquivo {
  font-size: 12px;
  font-weight: 700;
  word-break: break-all;
}

.orientacao-exemplo-legenda {
  font-size: 11px;
  opacity: 0.75;
  margin-top: 3px;
  line-height: 1.3;
}

.orientacao-zip-diagram {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  max-width: calc(100% - 8px);
  margin: 0 auto;
}

.orientacao-zip-icon-block {
  flex: 0 0 auto;
  text-align: center;
  min-width: 96px;
}

.orientacao-zip-icon-label {
  font-size: 12px;
  font-weight: 700;
  margin-top: 5px;
  white-space: nowrap;
  word-break: normal;
}

.orientacao-zip-bracket {
  flex: 0 0 14px;
  align-self: stretch;
  min-height: 100px;
  max-height: 112px;
  border: 2px solid var(--primary-color, #1976d2);
  border-right: none;
  border-radius: 10px 0 0 10px;
  margin-left: 4px;
}

.orientacao-zip-file-list {
  list-style: none;
  padding: 0;
  flex: 0 0 auto;
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.orientacao-zip-file-list li {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.75;
  word-break: break-all;
}

@media (max-width: 960px) {
  .orientacao-exemplos-grid {
    grid-template-columns: 1fr;
    row-gap: 12px;
    justify-items: center;
  }
}
</style>
